<template>
  <m-dialog ref="dlg" @save="save" :title="model && model.id ? 'Ubah Diklat' : 'Tambah Diklat'">
    <v-row row wrap justify="center" align="center">
      <v-col cols="12" sm="12" md="10" lg="8" xl="8">
        <FormGenerator autocomplete="false" @submit.prevent data-vv-scope="form" lazy-validation :field="schema" :model="model" :data="data" />
      </v-col>
    </v-row>
  </m-dialog>
</template>

<script>
import { ALERT_INFO } from "@/const";
import FormGenerator from "@/components/FormGenerator";

//@group Diklat
export default {
  name: "diklat-form",
  provide() {
    return { parentValidator: this.$validator };
  },
  $_veeValidate: {
    validator: "new"
  },
  components: {
    FormGenerator
  },

  data() {
    return {
      diklat: {},
      defDiklat: {
        instansi_id: null,
        nama: "",
        singkat: null,
        tanggal_mulai: "",
        tanggal_selesai: ""
      },
      alert: ALERT_INFO,
      current_page: 1,
      page: null,
      cp: 1,
      disableForm: false,
      data: {
        itemSeri: []
      },
      model: {},
      schema: [
        // {
        //   grid:{cols: 12},
        //   component: "VAutocomplete",
        //   model: "instansi_id",
        //   items: "itemSeri",
        //   properties: {
        //     name: "Seri",
        //     label: "Pilih Seri",
        //     placeholder: "Semua Seri",
        //     itemText:"nama",
        //     iteValue: "id",
        //     returnObject: true,
        //   }
        // },
        {
          grid: { cols: 12 },
          name: "nama",
          component: "VTextField",
          model: "nama",
          properties: {
            name: "Nama",
            placeholder: "Isikan Nama Diklat",
            label: "Nama"
          },
          validation: {
            dataVvName: "nama",
            dataVvAs: "Nama",
            vValidate: "required",
            errorMessages: "form.nama"
          }
        },
        {
          grid: { cols: 12 },
          component: "VTextField",
          model: "singkat",
          properties: {
            name: "singkat",
            placeholder: "Isikan Nama Singkat Diklat (Maksimal 10 Karakter)",
            label: "Nama Singkat"
          },
          validation: {
            dataVvName: "singkat",
            dataVvAs: "Nama",
            vValidate: "required|max:10",
            errorMessages: "form.singkat"
          }
        },
        {
          grid: { sm: 6, md: 6, lg: 6 },
          component: "datetime",
          model: "tanggal_mulai",
          properties: {
            type: "datetime",
            name: "tanggal_mulai",
            label: "Mulai Pendaftaran Peserta",
            format: { year: "numeric", month: "long", day: "numeric", hour: "numeric", minute: "2-digit" },
            phrases: { ok: "Lanjut", cancel: "Batal" }
          },
          class: "timepicker"
        },
        {
          grid: { sm: 6, md: 6, lg: 6 },
          component: "datetime",
          model: "tanggal_selesai",
          properties: {
            type: "datetime",
            name: "tanggal_selesai",
            label: "Selesai Pendaftaran Peserta",
            format: { year: "numeric", month: "long", day: "numeric", hour: "numeric", minute: "2-digit" },
            phrases: { ok: "Lanjut", cancel: "Batal" }
          },
          class: "timepicker"
        }
      ]
    };
  },
  methods: {
    // @vuese
    // Membuka dialog tambah / edit diklat
    // @args objek diklat
    open(obj) {
      this.loadSeri();

      this.model = obj ? { ...obj } : { ...this.defDiklat };
      if (obj) {
        this.model.tanggal_mulai = new Date(obj.tanggal_mulai).toISOString();
        this.model.tanggal_selesai = new Date(obj.tanggal_selesai).toISOString();
      } else {
        this.model.tanggal_mulai = new Date().toISOString();
        this.model.tanggal_selesai = new Date().toISOString();
      }
      let x = this.$refs.dlg.open();
      this.$validator.reset();
      return x;
    },
    // @vuese
    // Mengambil daftar seri untuk ditampilkan dalam Pilihan Diklat
    loadSeri() {
      return this.$store
        .dispatch("instansi/get", this.instansi_id)
        .then(res => {
          this.data.itemSeri = res;
          this.disableForm = false;
        })
        .catch(e => e);
    },
    // @vuese
    // Menyimpan data diklat
    save() {
      this.$validator
        .validateAll("form")
        .then(res => {
          if (!res) return Promise.reject();
          return res;
        })
        .then(() => {
          return this.$store
            .dispatch("diklat/form", {
              instansi_id: this.instansi_id,
              obj: this.model
            })
            .then(res => {
              this.$refs.dlg.resolve();
              this.$forceUpdate();
              return res;
            })
            .catch(e => e);
        })
        .catch(e => e);
    }
  }
};
</script>
<style>
.timepicker {
  color: rgba(0, 0, 0, 0.87);
  padding: 9px 8px 9px;
  max-width: 100%;
  width: 100%;
  border: 1px solid grey;
  outline: 1px;
  background: transparent;
  border-radius: 4px;
}
.vdatetime-input {
  width: 500px;
}
</style>
